export const { sanitizeUpper, toObject } = {
    sanitizeUpper: (s: string): string =>
        s.replace(/\s/g, '').replace(/"/g, '').toLocaleUpperCase(),
    toObject: (s: string): { [key: string]: string | number } | string => {
        try {
            const result = JSON.parse(s);
            // Type assertion to confirm the parsed JSON matches the desired type
            if (typeof result === 'object' && result !== null) {
                for (const key in result) {
                    if (
                        typeof result[key] !== 'string' &&
                        typeof result[key] !== 'number'
                    ) {
                        throw new Error('Invalid value type');
                    }
                }
                return result as { [key: string]: string | number };
            }
        } catch (e) {
            console.error('Invalid JSON string:', e);
        }
        return s;
    },
};
